module.exports = __webpack_public_path__ + "static/media/hot_2_badge.cb5e98fb.png";